import React from 'react';

function LimitLength({ display, style = {}, value, limit = 255 }) {
    return (
        display ? <p style={{ textAlign: 'right', color: '#ccc', ...style }}>{(value || '').length}/{limit}</p> : null
    );
}

export default LimitLength;


// WEBPACK FOOTER //
// ./src/components/basicElement/LimitLength.js